import * as types from '@/store/types.js'
import Slider from '@/model/Slider'
import {removeResource, activeResource} from '@/store/helpers'

const state = {
  sliders: {
    pagination: {},
    data: {}
  },
  activeSlider: {},
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_SLIDERS]: state => state.sliders,
  [types.ACTIVE_SLIDER]: state => state.activeSlider,
  [types.IS_LOADING_SLIDERS]: state => state.isLoading
}

// ACTIONS
const actions = {
  [types.GET_ALL_SLIDERS]: ({ commit }, value) => {
    commit(types.GET_ALL_SLIDERS, value)
  },
  [types.ADD_SLIDER]: ({ commit }, value) => {
    commit(types.ADD_SLIDER, value)
  },
  [types.REMOVE_SLIDER]: ({ commit }, value) => {
    commit(types.REMOVE_SLIDER, value)
  },
  [types.ACTIVE_SLIDER]: ({ commit }) => {
    commit(types.ACTIVE_SLIDER)
  },
  [types.IS_LOADING_SLIDERS]: ({ commit }, value) => {
    commit(types.IS_LOADING_SLIDERS, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_SLIDERS] (state, value) {
    state.sliders = value
  },
  [types.ADD_SLIDER]: (state, value) => {
    state.sliders.data.unshift(value)
  },
  [types.REMOVE_SLIDER]: (state, value) => {
    removeResource(Slider, value, state.sliders, 'sliders.index')
  },
  [types.ACTIVE_SLIDER]: (state, value) => {
    state.activeSlider = activeResource(state.sliders.data)
  },
  [types.IS_LOADING_SLIDERS]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Slider.js